import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";

import { PricingStrategy, PriceResult } from "../base/pricing.strategy";
import { ReactiveComponent } from "../../entities/base-component";
import { Door } from "../../entities/door";
import { DoorCut } from "../../entities/door-cut";

export class DoorPricingStrategy extends PricingStrategy {
    public getPrices(door: ReactiveComponent): PriceResult {
        return {
            price: this.calculateComponentsPriceForType(
                door as Door,
                CostDealType,
            ),
            priceB2C: this.calculateComponentsPriceForType(
                door as Door,
                B2CDealType,
            ),
            priceB2B: this.calculateComponentsPriceForType(
                door as Door,
                B2BDealType,
            ),
        };
    }

    private calculateComponentsPriceForType(door: Door, dealType: string) {
        // cuts price for 1 door
        const doorCuts = door.getActiveDoorCuts();
        const doorCutsPrice = doorCuts.reduce((total, cut) => {
            const qty = cut.qty === 0 ? 0 : cut.defaultQty
            const oneCutPrice = qty * cut.price.getSystemPrice(dealType).getValue();
            return total + oneCutPrice;
        }, 0)

        // hardwares price for 1 door
        const doorHardwares = door.getActiveHardwares();
        const doorHardwaresPrice = doorHardwares.reduce((total, hardware) => {
            const qty = hardware.qty === 0 ? 0 : hardware.defaultQty
            const oneHardwarePrice = qty * hardware.price.getSystemPrice(dealType).getValue();
            return total + oneHardwarePrice;
        }, 0)

        // glass price for 1 door
        const doorArea = door.dimensions.getAreaFt().toSquareFt().getValue();
        const glassPricePerSqFt = door.getActiveGlassPartition()?.price.getSystemPrice(dealType).getValue() || 0;
        const doorGlassPrice = +glassPricePerSqFt * doorArea

        const totalPricePerOneDoor = doorCutsPrice + doorHardwaresPrice + doorGlassPrice;
        return totalPricePerOneDoor
    }
}
